export default {
  pattern: 'Неверный формат, значение не отвечает шаблону',
  minItems: 'Недостаточно элементов, минимальное количество',
  maxItems: 'Слишком много элементов, максимальное количество',
  minimum: 'Значение должно быть не меньше',
  maximum: 'Значение должно быть не больше',
};
